/**
 * @generated SignedSource<<53df78f21c07a56e912df25417cc3bc9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ComplexMenuDesktopVerticalSubmenuItem_navigationItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "NavigationItem",
  "abstractKey": null
};

node.hash = "dae5ec87d7d46052943ae60ed970e181";

module.exports = node;
